import { SupplierItemCalculation } from '@retail/my-assortment/types';

export type SupplierPriorityTier = 'MAIN' | 'PRIORITIZED' | 'UNPRIORITIZED';

export interface SupplierPriorityItem {
  mgSupplierItemId: number;
  supplierName: string;
  tier: SupplierPriorityTier;
}

export function getInitialTier(
  supplierItem: Pick<SupplierItemCalculation, 'inAssortment' | 'prioritised'>
): SupplierPriorityTier {
  if (!supplierItem.inAssortment) return 'UNPRIORITIZED';
  return supplierItem.prioritised ? 'MAIN' : 'PRIORITIZED';
}
